(function () {
  function decodeMetaContent(metaTag) {
    if (!metaTag) return '';
    return decodeURIComponent(metaTag.getAttribute('content') || '').replace(/\+/g, ' ');
  }

  function getMoneyFormat() {
    var currencyCodeEnabled = document.querySelector('meta[name="currency-code-enabled"]');
    if (currencyCodeEnabled && currencyCodeEnabled.getAttribute('content') === 'true') {
      var withCurrencyMeta = document.querySelector('meta[name="money-with-currency-format"]');
      if (withCurrencyMeta) {
        return decodeMetaContent(withCurrencyMeta);
      }
    }

    var metaTag = document.querySelector('meta[name="money-format"]');
    if (metaTag) return decodeMetaContent(metaTag);

    if (window.money_format) return window.money_format;
    if (window.Shopify && window.Shopify.money_format) return window.Shopify.money_format;

    return '${{amount}}';
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    if (isNaN(number) || number == null) return '0';
    var fixed = number.toFixed(precision);
    var parts = fixed.split('.');
    var integer = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return precision > 0 ? integer + decimal + parts[1] : integer;
  }

  function formatMoneyManual(cents, format) {
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);

    if (!match) return '$' + (cents / 100).toFixed(2);

    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents / 100, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(Math.round(cents / 100), 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents / 100, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(Math.round(cents / 100), 0, '.', ',');
        break;
      default:
        value = (cents / 100).toFixed(2);
    }

    return format.replace(placeholderRegex, value);
  }

  function formatMoney(cents) {
    var amountInCents = Math.round(Number(cents));
    var moneyFormat = getMoneyFormat();

    if (window.Currency && typeof window.Currency.formatMoney === 'function') {
      return window.Currency.formatMoney(amountInCents, moneyFormat);
    }

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(amountInCents, moneyFormat);
    }

    if (moneyFormat) {
      return formatMoneyManual(amountInCents, moneyFormat);
    }

    return '$' + (amountInCents / 100).toFixed(2);
  }

  function buildCardPriceHtml(priceData) {
    if (!priceData) return '';

    var money = formatMoney(priceData.p);
    var compare = priceData.c || 0;
    var onSale = compare > priceData.p;
    var classes = 'font-bold price';

    if (!priceData.a) classes += ' price--sold-out';
    if (onSale) classes += ' price--on-sale';

    var html = '<div class="' + classes + '"><div class="price__container">';
    html += '<div class="price__regular">';
    html += '<span class="visually-hidden visually-hidden--inline">Regular price</span>';
    html += '<span class="price-item price-item--regular">' + money + '</span>';
    html += '</div>';
    html += '<div class="price__sale">';

    if (onSale) {
      html += '<span class="visually-hidden visually-hidden--inline">Regular price</span>';
      html += '<span><s class="price-item price-item--regular">' + formatMoney(compare) + '</s></span>';
    }

    html += '<span class="visually-hidden visually-hidden--inline">Sale price</span>';
    html += '<span class="price-item price-item--sale price-item--last">' + money + '</span>';
    html += '</div></div></div>';

    return html;
  }

  function initHoverImages() {
    document.querySelectorAll('.product-card-wrapper').forEach(function (card) {
      var hoverImg = card.querySelector('.card-hover-image');
      var mainImg = card.querySelector('img[id^="ProductCardImage"]');
      var mediaContainer = card.querySelector('.media.media--hover-effect');

      if (hoverImg && mediaContainer && mainImg) {
        if (window.getComputedStyle(mediaContainer).position !== 'relative') {
          mediaContainer.style.position = 'relative';
        }
        mainImg.style.position = 'relative';
        mainImg.style.zIndex = '0';
      }
    });
  }

  function selectSwatch(swatchButton, swatchList) {
    if (!swatchButton || !swatchButton.classList.contains('swatch-color')) return;

    var imageUrl = swatchButton.getAttribute('data-image');
    var hoverImageUrl = swatchButton.getAttribute('data-hover-image');
    var variantId = swatchButton.getAttribute('data-variant-id');
    var card = swatchButton.closest('.product-card-wrapper');

    if (!card) return;

    if (imageUrl) {
      var img = card.querySelector('img[id^="ProductCardImage"]');
      if (img) {
        img.src = imageUrl;
        img.srcset = imageUrl + ' 533w';
      }
    }

    if (hoverImageUrl) {
      var mediaContainer = card.querySelector('.media.media--hover-effect');
      var hoverImg = card.querySelector('.card-hover-image');
      var mainImg = card.querySelector('img[id^="ProductCardImage"]');

      if (mediaContainer && !hoverImg) {
        hoverImg = document.createElement('img');
        hoverImg.className = 'motion-reduce card-hover-image';
        if (mainImg) {
          hoverImg.width = mainImg.width;
          hoverImg.height = mainImg.height;
          if (mainImg.getAttribute('loading')) {
            hoverImg.setAttribute('loading', mainImg.getAttribute('loading'));
          }
        }
        hoverImg.alt = '';
        hoverImg.loading = 'lazy';
        mediaContainer.appendChild(hoverImg);
      }

      if (hoverImg) {
        hoverImg.src = hoverImageUrl;
        hoverImg.srcset = hoverImageUrl + ' 533w';
      }
    }

    if (variantId) {
      var link = card.querySelector('a[id^="CardLink-"]');
      var imageLink = card.querySelector('.card__media-link');
      if (link) {
        var url = link.getAttribute('href').split('?')[0];
        link.setAttribute('href', url + '?variant=' + variantId);
      }
      if (imageLink) {
        var imgUrl = imageLink.getAttribute('href').split('?')[0];
        imageLink.setAttribute('href', imgUrl + '?variant=' + variantId);
      }
    }

    var priceHost = card.querySelector('.js-card-product-price');
    var pricesJsonEl = card.querySelector('script.js-card-variant-prices[type="application/json"]');
    if (priceHost && pricesJsonEl && variantId) {
      try {
        var pricesByVariant = JSON.parse(pricesJsonEl.textContent);
        var priceData = pricesByVariant[variantId] || pricesByVariant[String(variantId)];
        var nextPriceHtml = buildCardPriceHtml(priceData);
        if (nextPriceHtml) {
          priceHost.innerHTML = nextPriceHtml;
        }
      } catch (parseErr) {}
    }

    swatchList.querySelectorAll('.swatch-color').forEach(function (btn) {
      btn.classList.remove('active');
    });
    swatchButton.classList.add('active');
  }

  function initSwatches() {
    document.querySelectorAll('.product-card-swatches').forEach(function (swatchList) {
      if (swatchList.dataset.swatchInit === 'true') return;
      swatchList.dataset.swatchInit = 'true';

      var buttons = swatchList.querySelectorAll('.swatch-color');

      swatchList.addEventListener('click', function (e) {
        if (!e.target.classList.contains('swatch-color')) return;
        selectSwatch(e.target, swatchList);
      });

      if (buttons.length > 0) {
        var firstButton = buttons[0];
        var firstImageUrl = firstButton.getAttribute('data-image');
        var firstHoverImageUrl = firstButton.getAttribute('data-hover-image');
        if (firstImageUrl || firstHoverImageUrl) {
          selectSwatch(firstButton, swatchList);
        }
      }
    });
  }

  function initProductCards() {
    initHoverImages();
    initSwatches();
  }

  window.initProductCardSwatches = initProductCards;

  document.addEventListener('DOMContentLoaded', initProductCards);
  document.addEventListener('shopify:section:load', initProductCards);
})();
